import React from "react";
import ReactGA from "react-ga4";

//Components
import Navbar from "./components/Navbar";
import Summary from "./components/Summary";

//Views
import NAForm from "./views/NAForm";
import Network from "./views/Network";
import Security from "./views/Security";
import Tv from "./views/Tv";
import TvPackages from "./views/TvPackages";
import TvFlexChannels from "./views/TvFlexChannels";
import BroadbandEquipment from "./views/BroadbandEquipment";
import TvEquipment from "./views/TvEquipment";
import Form from "./views/Form";

//Hooks
import useGetData from "./hooks/useGetData";

//Stores
import useGlobalStore from "./stores/globalStore";
import Broadband from "./views/Broadband";

ReactGA.initialize("G-J80MLEDZ4V");

function App() {
  //States
  const selectedNetwork = useGlobalStore((state) => state.selectedNetwork);
  const activeView = useGlobalStore((state) => state.activeView);
  //Hooks
  const networks = useGetData();

  return (
    <form className="tel-pt-form">
      <Navbar isPending={networks.isPending} />

      <div className="tel-pt-form__views">
        <NAForm isVisible={activeView === 0} />
        <Network isVisible={activeView === 1} networks={networks} />
        <Broadband isVisible={activeView === 2} network={selectedNetwork} />
        <BroadbandEquipment isVisible={activeView === 3} network={selectedNetwork} />
        <Tv isVisible={activeView === 4} network={selectedNetwork} />
        <TvPackages isVisible={activeView === 5} network={selectedNetwork} />
        <TvFlexChannels isVisible={activeView === 6} flexChannels={networks.flexChannels} />
        <TvEquipment isVisible={activeView === 7} network={selectedNetwork} />
        <Security isVisible={activeView === 8} network={selectedNetwork} />
        <Form isVisible={activeView === 9} />
      </div>

      <Summary />

      <Navbar isPending={networks.isPending} />
    </form>
  );
}

export default App;
